import { styled } from '@mui/material';
import { Form } from 'formik';

export const FilesAttachmentContainer = styled(Form)(({ theme }) => ({
  height: '100%',
  '&::-webkit-scrollbar': {
    width: '6px',
  },
  '&::-webkit-scrollbar-track': {
    boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
    webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.colors.scrollOnPrimaryBackground,
    borderRadius: '5px',
  },
  [theme.breakpoints.down('lg')]: {
    '& .MuiFormControl-root:nth-child(3)': {
      marginBottom: '34px',
    },
  },

  '& .formButtonsContainer': {
    justifyContent: 'center',

    '.submitButton, .backButton': {
      width: '148px',

      [theme.breakpoints.up('md')]: {
        width: '212px',
      },
      [theme.breakpoints.up('lg')]: {
        width: '148px',
      },
    },
  },
}));

export const Wrapper = styled('div')(({ theme }) => ({
  '& .MuiFormGroup-root': {
    flexDirection: 'row',
    justifyContent: 'start',
  },
  paddingTop: '24px',
  '&:nth-child(1)': {
    paddingTop: 0,
  },
  borderBottom: `1px solid ${theme.palette.colors.scrollOnPrimaryBackground}`,
  display: 'flex',
  flexDirection: 'column',
  '& .MuiChip-root': {
    alignSelf: 'end',
  },
  paddingBottom: '16px',
}));

export const WrapperRadioDate = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '16px',
  [theme.breakpoints.down('xxl')]: {
    flexDirection: 'column',
    gap: 0,
  },
  '& .MuiFormGroup-root': {
    flexDirection: 'row',
    justifyContent: 'start !important',
    gap: '8px',
    [theme.breakpoints.between('md', 'lg')]: {
      '& .MuiFormControlLabel-root': {
        width: '214px',
      },
      justifyContent: 'space-between !important',
      gap: 0,
    },
    [theme.breakpoints.down('md')]: {
      gap: 0,
      justifyContent: 'space-between !important',
    },
  },
}));
